var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      attrs: { id: "form", method: "post", action: "" },
      on: {
        submit: function ($event) {
          $event.preventDefault()
          return _vm.onSubmit.apply(null, arguments)
        },
      },
    },
    [
      _c("span", { attrs: { id: "upload-progressbar" } }),
      _c("textarea", {
        ref: "input",
        staticClass: "mousetrap",
        attrs: {
          id: "input",
          dir: "auto",
          enterkeyhint: "send",
          placeholder: _vm.getInputPlaceholder(_vm.channel),
          "aria-label": _vm.getInputPlaceholder(_vm.channel),
        },
        domProps: { value: _vm.channel.pendingMessage },
        on: {
          input: _vm.setPendingMessage,
          keypress: function ($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
            ) {
              return null
            }
            if (
              $event.ctrlKey ||
              $event.shiftKey ||
              $event.altKey ||
              $event.metaKey
            ) {
              return null
            }
            $event.preventDefault()
            return _vm.onSubmit.apply(null, arguments)
          },
        },
      }),
      _vm.$store.state.serverConfiguration.fileUpload
        ? _c(
            "span",
            {
              staticClass: "tooltipped tooltipped-w tooltipped-no-touch",
              attrs: { id: "upload-tooltip", "aria-label": "Upload file" },
              on: { click: _vm.openFileUpload },
            },
            [
              _c("input", {
                ref: "uploadInput",
                attrs: {
                  id: "upload-input",
                  type: "file",
                  "aria-labelledby": "upload",
                  multiple: "",
                },
                on: { change: _vm.onUploadInputChange },
              }),
              _c("button", {
                attrs: {
                  id: "upload",
                  type: "button",
                  "aria-label": "Upload file",
                  disabled: !_vm.$store.state.isConnected,
                },
              }),
            ]
          )
        : _vm._e(),
      _c(
        "span",
        {
          staticClass: "tooltipped tooltipped-w tooltipped-no-touch",
          attrs: { id: "submit-tooltip", "aria-label": "Send message" },
        },
        [
          _c("button", {
            attrs: {
              id: "submit",
              type: "submit",
              "aria-label": "Send message",
              disabled: !_vm.$store.state.isConnected,
            },
          }),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }